export default __webpack_public_path__ + "6d964ac2439b4e11afd25d1d47df88b6.woff2";